import PropTypes from 'prop-types';
import { SnackbarProvider } from 'notistack';

import { BennieSnackbarContent } from './BennieSnackbarContent';
import { getSnackbarOptions } from './config';

const snackbarComponents = {
  default: BennieSnackbarContent,
  success: BennieSnackbarContent,
  error: BennieSnackbarContent,
  warning: BennieSnackbarContent,
  info: BennieSnackbarContent,
};

const Provider = ({ children }) => {
  return (
    <SnackbarProvider
      {...getSnackbarOptions()}
      Components={snackbarComponents}
      data-testid="snackbar-provider"
    >
      {children}
    </SnackbarProvider>
  );
};

Provider.propTypes = {
  children: PropTypes.node,
};

export default Provider;
